module.exports = __webpack_public_path__ + "static/justdata-d8080a022b2ca55908d7eb81dd7f0509.png";